import { erpAxios } from '..';

const editSegmentation = async (data) => {
  const res = await erpAxios.post(`/segmentation/edit`, data);
  return res;
};

export default editSegmentation;
